var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "entry-profile" },
    [
      _vm.loadState === "error"
        ? _c("p", { staticClass: "load-error", attrs: { role: "alert" } }, [
            _vm._v(_vm._s(_vm.$t("entryProfile.loadError"))),
          ])
        : _vm.loadState === "loaded"
        ? [
            _c(
              "button",
              {
                staticClass: "edit-user-button",
                attrs: { type: "button" },
                on: { click: _vm.onClickEditUserInfo },
              },
              [_vm._v(" " + _vm._s(_vm.$t("entryProfile.editUserInfo")) + " ")]
            ),
            _vm.showEditDialog
              ? _c("my-page-user-info-edit-dialog", {
                  attrs: {
                    profile: _vm.profile,
                    "nola-penname": _vm.nolaPenname,
                  },
                  on: {
                    close: function ($event) {
                      _vm.showEditDialog = false
                    },
                    updated: _vm.onUserInfoUpdated,
                  },
                })
              : _vm._e(),
            _c("hr", { staticClass: "divider" }),
            _c("p", { staticClass: "history-description" }, [
              _vm._v(_vm._s(_vm.$t("entryProfile.historyDescription"))),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "field-header" }, [
                _c(
                  "label",
                  {
                    staticClass: "field-label",
                    attrs: { for: "history-of-awards" },
                  },
                  [_vm._v(_vm._s(_vm.$t("entryProfile.historyOfAwards.label")))]
                ),
                _c("span", { staticClass: "field-count" }, [
                  _vm._v(
                    _vm._s(_vm.historyOfAwards.length) +
                      "/" +
                      _vm._s(_vm.historyMaxLength)
                  ),
                ]),
              ]),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.historyOfAwards,
                    expression: "historyOfAwards",
                  },
                ],
                staticClass: "field-textarea",
                class: { error: !!_vm.error },
                attrs: {
                  id: "history-of-awards",
                  maxlength: _vm.historyMaxLength,
                  placeholder: _vm.$t(
                    "entryProfile.historyOfAwards.placeholder"
                  ),
                },
                domProps: { value: _vm.historyOfAwards },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.historyOfAwards = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _vm.error
                ? _c("p", { staticClass: "field-error" }, [
                    _vm._v(_vm._s(_vm.error)),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "footer" }, [
              _c(
                "button",
                {
                  staticClass: "update-button",
                  attrs: { type: "button", disabled: _vm.saving },
                  on: { click: _vm.onClickUpdate },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("entryProfile.updateHistory")) + " "
                  ),
                ]
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }